export default __webpack_public_path__ + "static/media/generic_thumb_3.7556458b.png";